"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConnectDevices = void 0;
var _reactRedux = require("react-redux");
var _react = require("react");
var _user = require("../../../entities/user");
var _devices = require("../../../entities/devices");
var _useGetValues = require("./useGetValues");
var _useGetDeviceValues = require("./useGetDeviceValues");
var _useGetDeviceValue = require("./useGetDeviceValue");
var _sites = require("../../../entities/sites");
const socketIdDevices = 'gsqZr2s6z0s_1StV6z';
const useConnectDevices = () => {
  const token = (0, _reactRedux.useSelector)(_user.selectToken);
  const dispatch = (0, _reactRedux.useDispatch)();
  const activeSiteId = (0, _reactRedux.useSelector)(_sites.selectActiveSiteId);
  const {
    api: apiURL
  } = (0, _reactRedux.useSelector)(_user.selectUrls);
  (0, _useGetValues.useGetValues)({
    socketId: socketIdDevices,
    baseUrl: apiURL
  });
  (0, _useGetDeviceValue.useGetDeviceValue)({
    socketId: socketIdDevices,
    baseUrl: apiURL
  });
  (0, _useGetDeviceValues.useGetDeviceValues)();
  (0, _react.useEffect)(() => {
    if (token && activeSiteId) {
      dispatch((0, _devices.getDevicesAction)({
        siteId: activeSiteId
      }));
    }
  }, [activeSiteId, dispatch, token]);
  (0, _react.useEffect)(() => {
    if (!activeSiteId) dispatch((0, _devices.resetAllDevicesAction)());
  }, [dispatch, activeSiteId]);
};
exports.useConnectDevices = useConnectDevices;